module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture20-74e377397f386520ad7d79f9a254008e.jpg";